import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { authGoogleUserWithAPI } from '../services/authentication/authWithGoogle';
import { setUserSession } from '../store/slices/UserSession/userSession';
import { PluginListenerHandle } from '@capacitor/core';
import useIonicToast from './useIonicToast';
import { usePageLoader } from '../context/pageLoader';
import { RootState } from '../store/store';

export default function useNativeGoogleAuth() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { presentIonToast } = useIonicToast();
  const { setBusy } = usePageLoader();
  const { isNative } = useSelector((state: RootState) => state.settings);

  const sendGoogleTokenToBackend = async (code: string) => {
    try {
      setBusy(true);
      const res = await authGoogleUserWithAPI(code);
      dispatch(setUserSession(res));
      history.replace('/dashboard');
    } catch (error: any) {
      presentIonToast(
        error.message || 'Something went wrong, try again!',
        'error'
      );
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (!isNative) return;
    let sub: PluginListenerHandle;
    (async () => {
      sub = await App.addListener('appUrlOpen', async ({ url }) => {
        if (!url.includes('auth-callback')) return;
        const code = new URL(url).searchParams.get('code');
        if (!code) return;
        await Browser.close();
        await sendGoogleTokenToBackend(code);
      });
    })();
    return () => {
      if (sub) sub.remove();
    };
  }, []);
}
